import { useEffect, useRef, useState } from "react";

export default function Attendance() {
    const [vacationNumber, setVacationNumber] = useState(56);
    const [remainingVacationNumber, setRemainingVacationNumber] = useState(vacationNumber);
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [reason, setReason] = useState("");

    const handleSubmit = () => {
        if (remainingVacationNumber > 0) {
            setRemainingVacationNumber(prev => prev - 1)
        }
    }

    return (
        <div className="wrapper">
            <div><strong>Attendance</strong></div>
            <div>可用假數：{vacationNumber} 小時</div>
            <div>剩餘假數：{remainingVacationNumber} 小時</div>
            <label>請假起日：
                <input type="date" value={start} onChange={e => setStart(e.target.value)} />
            </label>
            <br />
            <label>請假迄日：
                <input type="date" value={end} onChange={e => setEnd(e.target.value)} />
            </label>
            <br />
            <label>事由：
                <br />
                <textarea value={reason} onChange={e => setReason(e.target.value)} />
            </label>
            <br />
            <button onClick={handleSubmit}>送出</button>
        </div>
    )
}
